export default  {
  bindings: {
    exclusion: '<',
    inclusion: '<',
  },
  controller: 'availabilityListController',
  template: require('../views/availability.list.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/components/availability.list.component.js